<div class="flex flex-row align-items-center status-badge px-3" [class]="[getStatusBadgeClass(status), getPaddingClass()].join(' ')">
    @if (icon) {
        <lib-svg-icon [svgName]="icon" [svgHeight]="svgHeight + 'px'" [svgWidth]="svgWidth + 'px'"></lib-svg-icon>
    }
    <span [style.font-size]="badgeSize ? badgeSize : '14px'">{{message}}</span>
</div>